import axiosBase from "axios";
import { axios } from "./axiosSettings";
import { getAuthHeader } from "../helpers/session";
import { FETCH_CANCEL_MESSAGE } from "../constants/constants";

let cancelToken;
const chartLinesToken = {};

export const fetchCharts = async (vesselId) => {
  if (typeof cancelToken !== typeof undefined) {
    cancelToken.cancel(FETCH_CANCEL_MESSAGE);
  }

  cancelToken = axiosBase.CancelToken.source();

  try {
    const { data } = await axios.get(`/api/charts`, {
      params: {
        vesselId,
      },
      headers: getAuthHeader(),
      cancelToken: cancelToken.token,
    });
    return { charts: data };
  } catch (e) {
    throw { fetchCharts: e };
  }
};

export const fetchChartLines = async (vesselId, chartId) => {
  if (typeof chartLinesToken[chartId] !== typeof undefined) {
    chartLinesToken[chartId].cancel(FETCH_CANCEL_MESSAGE);
  }

  chartLinesToken[chartId] = axiosBase.CancelToken.source();

  try {
    const { data } = await axios.get(`/api/charts/line`, {
      params: {
        vesselId,
        id: chartId,
      },
      headers: getAuthHeader(),
      cancelToken: chartLinesToken[chartId].token,
    });
    return { chartLines: data };
  } catch (e) {
    throw { fetchChartLines: e };
  }
};

export const updateCharts = async (chart) => {
  if (typeof cancelToken !== typeof undefined) {
    cancelToken.cancel(FETCH_CANCEL_MESSAGE);
  }

  cancelToken = axiosBase.CancelToken.source();

  try {
    const { data } = await axios.post(`/api/charts`, chart, {
      headers: getAuthHeader(),
      cancelToken: cancelToken.token,
    });
    return { charts: data };
  } catch (e) {
    throw { updateCharts: e };
  }
};

export const updateLines = async (vesselId, type, chartType, line, color, visible) => {
  if (typeof cancelToken !== typeof undefined) {
    cancelToken.cancel(FETCH_CANCEL_MESSAGE);
  }

  cancelToken = axiosBase.CancelToken.source();

  try {
    const { data } = await axios.post(
      `/api/charts/line`,
      {
        vesselId,
        type,
        chartType,
        line: line.replace(/"/g, ""),
        color,
        visible,
      },
      {
        headers: getAuthHeader(),
        cancelToken: cancelToken.token,
      }
    );
    return { trendCharts: data };
  } catch (e) {
    throw { updateLines: e };
  }
};

export const deleteChart = async (vesselId, chartId) => {
  if (typeof cancelToken !== typeof undefined) {
    cancelToken.cancel(FETCH_CANCEL_MESSAGE);
  }

  cancelToken = axiosBase.CancelToken.source();

  try {
    const { data } = await axios.delete(`/api/charts`, {
      params: {
        vesselId,
        chartId,
      },
      headers: getAuthHeader(),
      cancelToken: cancelToken.token,
    });
    return { charts: data };
  } catch (e) {
    throw { deleteChart: e };
  }
};
